//load our custom elements
require("component-leaflet-map");
require("component-responsive-frame");

//get access to Leaflet and the map
var element = document.querySelector("leaflet-map");
var L = element.leaflet;
var map = element.map;


var $ = require("jquery");
var dot = require("./lib/dot");

var table = dot.compile(require("./_table.html"));
var data = require("./map.geo.json");
$(".table").html(table(data.features));


//ICH code for popup template if needed----------
var ich = require("icanhaz");
var templateFile = require("./_popup.html");
ich.addTemplate("popup", templateFile);

var stateData = require("./_states.html");
ich.addTemplate("stateInfo", stateData);


 map.scrollWheelZoom.disable();

 var shootingMap = {};

var onEachFeature = function(feature, layer) {
  layer.bindPopup(ich.popup(feature.properties));
  if (feature.properties.incident_date) {
    shootingMap[feature.properties.incident_date] = layer;
  }
};


 function geojsonMarkerOptions(feature) {
  return {
    radius: 10,
    fillColor: "rgb(225, 135, 39)",
    color: "#ffffff",
    weight: 1,
    opacity: 1,
    fillOpacity: 0.6
  }
};


 var geojson = L.geoJson(data, {
     pointToLayer: function (feature, latlng) {
         return L.circleMarker(latlng);
     },
     style: geojsonMarkerOptions,
     onEachFeature: onEachFeature
 }).addTo(map);

map.fitBounds(geojson.getBounds());


var listContainer = $(".table");
listContainer.on("click", "tr[shooting-data]", function(){
  var shooting = this.getAttribute("shooting-data");
  var layer = shootingMap[shooting];
  if (!layer) return;
  layer.openPopup();
  var latlng = layer.getLatLng();
  map.fitBounds([latlng, latlng], {maxZoom: 12, paddingTopLeft:[0,100]});
});

var $chart = $('.states');

var $toolTip = $chart
  .append('<div class="tooltip"></div>')
  .find('.tooltip')
  .hide();

$chart.on('mouseenter', 'g[id]', function() {
  var state = this.getAttribute("id");
  var $state = $(this);
  // $toolTip.html('<span class="popuptitle">' + exportData[state].state + '</span><br><div class="popuptext">Population: ' + exportData[state].population + '</div>').show();

    $toolTip.html(ich.stateInfo(exportData[state])).show();
});

$chart.on('mouseleave', 'g', function() {
  $toolTip.hide();
});

$chart.on('mousemove', function(e) {
  var bounds = $chart[0].getBoundingClientRect();
  var mouse = { left: e.clientX, top: e.clientY };
  var tWidth = $toolTip.width();
  var position = {
    left: mouse.left - bounds.left - tWidth / 2 - 30,
    top: mouse.top - bounds.top - $toolTip.height() - 40
  };
  if (position.left < 0) position.left = 0;
  if (position.left + tWidth > bounds.width) position.left = bounds.width - tWidth;
  position.left += "px";
  position.top += "px";
  $toolTip.css(position);
});
